import Link from 'next/link'
import { LeftArrowIcon, RightArrowIcon } from 'components/content/icons'
import { ID } from 'lib'
import classNames from 'classnames'
import { goto, GoToVariants } from './GoTo.css'
import { UrlObject } from 'url'
import { ReactNode } from 'react'

type ClickProps =
	| {
			onClick?: () => void
			href?: never
	  }
	| {
			onClick?: never
			href: UrlObject | string
	  }

interface Props {
	className?: string | undefined
	children: string
	direction: 'left' | 'right' | 'none'
}

type AllProps = ClickProps & Props & GoToVariants

const getChildren = (direction: 'left' | 'right' | 'none', children: string) => {
	let content: ReactNode
	content = [children, ' ', <RightArrowIcon key={ID()} />]

	if (direction === 'left') {
		content = [<LeftArrowIcon key={ID()} />, ' ', children]
	}
	if (direction === 'none') {
		content = children
	}
	return content
}

export const GoTo = ({ href, className, direction = 'right', color, children, onClick }: AllProps) => {
	const descendants = getChildren(direction, children)

	if (href) {
		return (
			<Link href={href} passHref className={classNames(goto({ color: color }), className)}>
				{descendants}
			</Link>
		)
	}

	return (
		<span onClick={onClick} className={classNames(goto({ color: color }), className)}>
			{descendants}
		</span>
	)
}
